const username = process.env.REACT_APP_PUBLIC_API_USERNAME || 'creator_public';
const password = process.env.REACT_APP_PUBLIC_API_PASSWORD || 'creator_public_2026';

export const publicApiHeaders = {
  Authorization: `Basic ${window.btoa(`${username}:${password}`)}`,
};
